/* eslint-disable */
import { HTMLMotionProps, motion } from 'framer-motion'
import { useModalContext } from '../modal'
import cls from 'classnames'
import * as React from 'react'
import type * as Polymorphic from '../../../../react-utils/polymorphic'

export interface ModalOverlayProps
  extends Omit<HTMLMotionProps<'div'>, 'color' | 'transition'> {
  children?: React.ReactNode
  /**
   * ZIndex stuff for custom position on screen
   */
  zIndex?: string
  bgOpacity?: string
}

const MotionDiv = motion.div

/**
 * ModalOverlay renders a backdrop behind the modal. It is
 * also used as a wrapper for the modal content for better positioning.
 */
export const ModalOverlay = React.forwardRef((props, ref) => {
  const { className, bgOpacity = '0.48', transition, zIndex, ...rest } = props
  const _className = cls('overlay_modal', className)

  const overlayStyle: React.CSSProperties = {
    position: 'fixed',
    left: '0',
    top: '0',
    width: '100vw',
    height: '100vh',
    background: `rgba(0, 0, 0, ${bgOpacity})`,
    opacity: 1,
    zIndex: zIndex,
  }

  const { motionPreset } = useModalContext()
  const motionProps: any = motionPreset === 'none' ? {} : ''

  return (
    <MotionDiv
      {...motionProps}
      style={{ ...overlayStyle }}
      ref={ref}
      className={_className}
      {...rest}
    />
  )
}) as Polymorphic.ForwardRefComponent<any, ModalOverlayProps>

ModalOverlay.displayName = 'ModalOverlay'
